import React, { useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Row, Button, Col, Card } from "antd";
import { formatAmount, getSum } from "../../utils/Common";
import Navbar from "../../components/Navbar/Navbar";
import { UsePostRequest } from "../../utils/api/ApiRequests";
import moment from "moment";
import ReactToPrint from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo.png";

export default function Payslip() {
  const componentRef = useRef();
  const params = useParams();
  const payrollId = params.id;
  const [payrollData, setPayrollData] = useState({});

  function formatDateRange(dateFrom, dateTo) {
    if (moment(dateFrom).format("YYYY") === moment(dateTo).format("YYYY")) {
      return `${moment(dateFrom).format("MMMM DD")} - ${moment(dateTo).format(
        "MMMM DD, YYYY"
      )}`;
    } else {
      return `${moment(dateFrom).format("MMMM DD, YYYY")} - ${moment(
        dateTo
      ).format("MMMM DD, YYYY")}`;
    }
  }

  React.useEffect(() => {
    async function fetchPayrollData() {
      const response = await UsePostRequest("payrolls/get", {
        payroll_id: payrollId,
      });
      if (response.data) {
        const payroll = response.data[0];
        // const tempEarnings = [];
        // const tempdDeductions = [];
        const info = payroll;
        info.id = payroll.id;
        info.salary = Number(payroll.basic_pay);
        info.date_from = payroll.date_from;
        info.date_to = payroll.date_to;
        info.allowance = getSum([
          payroll.ecola_allowance,
          payroll.project_allowance,
        ]);
        setPayrollData(info);
      }
    }

    fetchPayrollData();
  }, []);

  function renderMonthlyTypePayslip() {
    return (
      <Card className="p-3">
        <Row>
          <Col xs={24} sm={8} lg={2} className="me-4">
            <img src={logo} alt="logo" className="view-page-logo" />
          </Col>
        </Row>
        <Row>
          I hereby acknowledge to have received from Hungry Hailey Corporation
          located at #205B One Paseo, Paseo Saturnino, Banilad, Cebu City, Cebu, 6000 the amount specified in
          Net Pay as compensation of our services redered.
        </Row>
        <Row>
          <Col xs={24} sm={20} md={20} lg={18}>
            <table className="table table-bordered mt-3 payslip-table">
              <tbody>
                <tr>
                  <td className="bold">Employee Name</td>
                  <td colSpan={3}>{payrollData.employee_name}</td>
                </tr>
                <tr>
                  <td className="bold">Pay Period</td>
                  <td colSpan={3}>
                    {formatDateRange(
                      payrollData.date_from,
                      payrollData.date_to
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="bold">Semi-monthly rate</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.basic_pay)}
                  </td>
                </tr>
                <tr>
                  <td className="bold text-center">Type of Work Days</td>
                  <td className="bold text-center">Amount</td>
                  <td className="bold text-center" colSpan={2}>
                    Details
                  </td>
                </tr>
                <tr>
                  <td className="">Regular Work Day</td>
                  <td className="text-end">{formatAmount(payrollData.basic_pay)}</td>
                  <td className="text-center">{payrollData.work_days}</td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="">Sunday</td>
                  <td className="text-end">{formatAmount(payrollData.restday_ot_pay)}</td>
                  <td className="text-center">{payrollData.restday_ot_hr}</td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="">Holiday</td>
                  <td className="text-end">
                    {formatAmount(getSum([
                      payrollData.regular_holiday_pay,
                      payrollData.special_holiday_pay,
                    ]))}
                  </td>
                  <td className="text-center"></td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="bold" colSpan={4}>
                    Add
                  </td>
                </tr>
                <tr>
                  <td className="ps-4">Overtime</td>
                  <td className="text-end">
                    {formatAmount(getSum([
                      payrollData.regular_ot_pay,
                      payrollData.restday_ot_pay,
                    ]))}
                  </td>
                  <td className="text-center">
                    {getSum([
                      payrollData.regular_ot_hr,
                      payrollData.restday_ot_hr,
                    ])}
                  </td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="ps-4">Paid Sick Leave</td>
                  <td className="text-end">
                    {formatAmount(payrollData.sick_leave_pay)}
                  </td>
                  <td className="text-center">
                    {payrollData.sick_leave_days}
                  </td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="ps-4">Paid Vacation Leave</td>
                  <td className="text-end">
                    {formatAmount(payrollData.vacation_leave_pay)}
                  </td>
                  <td className="text-center">
                    {payrollData.vacation_leave_days}
                  </td>
                  <td className="">day/s</td>
                </tr>
                {
                  parseFloat(payrollData.project_allowance)>0 &&
                  <tr>
                    <td className="ps-4">Allowances</td>
                    <td className="text-end">
                      {formatAmount(payrollData.project_allowance)}
                    </td>
                    <td className="text-center"></td>
                    <td className="">---</td>
                  </tr>
                }
                {
                  parseFloat(payrollData.ecola_allowance)>0 &&
                  <tr>
                  <td className="ps-4">ECOLA</td>
                  <td className="text-end">
                    {formatAmount(payrollData.ecola_allowance)}
                  </td>
                  <td className="text-center"></td>
                  <td className="">---</td>
                </tr>
                }
                {
                  parseFloat(payrollData.incentives)>0 &&
                  <tr>
                  <td className="ps-4">Incentives</td>
                  <td className="text-end">
                    {formatAmount(payrollData.incentives)}
                  </td>
                  <td className="text-center"></td>
                  <td className="">---</td>
                </tr>
                }
                <tr>
                  <td className="bold">Salary Adjustment</td>
                  <td colSpan={3} className="bold text-end">
                    {formatAmount(payrollData.salary_adjustment)}
                  </td>
                </tr>
                <tr>
                  <td className="bold">Total Gross Pay</td>
                  <td colSpan={3} className="bold text-end">
                    {formatAmount(payrollData.gross_pay)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={4}>
                    Less: Deductions
                  </td>
                </tr>
                <tr>
                  <td className="">Undertime</td>
                  <td className="text-end">{formatAmount(payrollData.undertime)}</td>
                  <td className="text-center">{payrollData.undertime_hr}</td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="">Late</td>
                  <td className="text-end">{formatAmount(payrollData.late)}</td>
                  <td className="text-center">{payrollData.late_hr}</td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="">SSS</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.sss)}
                  </td>
                </tr>
                <tr>
                  <td className="">PhilHealth</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.philhealth)}
                  </td>
                </tr>
                <tr>
                  <td className="">Pag-IBIG</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.hdmf)}
                  </td>
                </tr>
                {parseFloat(payrollData.sss_loan) > 0 && (
                  <tr>
                    <td className="">SSS Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.sss_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.pagibig_loan) > 0 && (
                  <tr>
                    <td className="">Pag-IBIG Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.pagibig_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.ppes_loan) > 0 && (
                  <tr>
                    <td className="">PPEs Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.ppes_loan)}
                    </td>
                  </tr>
                )}

                {parseFloat(payrollData.cash_advance) > 0 && (
                  <tr>
                    <td className="">Cash Advance</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.cash_advance)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.cooperative_loan) > 0 && (
                  <tr>
                    <td className="">Cooperative Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.cooperative_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.other_loan) > 0 && (
                  <tr>
                    <td className="">Other Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.other_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.coop) > 0 && (
                  <tr>
                    <td className="">Coop Contribution</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.coop)}
                    </td>
                  </tr>
                )}

                <tr>
                  <td className="bold">Total Deductions</td>
                  <td className="bold text-end" colSpan={3}>
                    {formatAmount(payrollData.total_deductions)}
                  </td>
                </tr>
                <tr>
                  <td className="bold">NET PAY</td>
                  <td className="bold text-end" colSpan={3}>
                    {formatAmount(payrollData.total_net_pay)}
                  </td>
                </tr>
                <tr className="">
                  <td className="no-border-cell" colSpan={4}></td>
                </tr>
                <tr className="">
                  <td className="bold text-center" colSpan={4}>
                    Breakdown of Advances
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Balance from previous month
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.prev_balance)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Total Payments
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.total_payment)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Balance still to be paid
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.balance)}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Card>
    );
  }

  function renderWeeklyTypePayslip() {
    return (
      <Card className="p-3">
        <Row>
          <Col xs={24} sm={8} lg={2} className="me-4">
            <img src={logo} alt="logo" className="view-page-logo" />
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={20} md={20} lg={18}>
            <table className="table table-bordered mt-3 payslip-table">
              <tbody>
                <tr>
                  <td className="bold">Employee Name</td>
                  <td colSpan={3}>{payrollData.employee_name}</td>
                </tr>
                <tr>
                  <td className="bold">Pay Period</td>
                  <td colSpan={3}>
                    {formatDateRange(
                      payrollData.date_from,
                      payrollData.date_to
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="bold">Daily rate</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.basic_rate)}
                  </td>
                </tr>
                <tr>
                  <td className="bold text-center">Type of Work Days</td>
                  <td className="bold text-center">Amount</td>
                  <td className="bold text-center" colSpan={2}>
                    Details
                  </td>
                </tr>
                <tr>
                  <td className="">Regular Work Day</td>
                  <td className="text-end">{formatAmount(payrollData.basic_pay)}</td>
                  <td className="text-center">{payrollData.work_days}</td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="">Monday</td>
                  <td className="text-end">{formatAmount(payrollData.restday_ot_pay)}</td>
                  <td className="text-center">{payrollData.restday_ot_hr}</td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="">Holiday</td>
                  <td className="text-end">
                    {formatAmount(getSum([
                      payrollData.regular_holiday_pay,
                      payrollData.special_holiday_pay,
                    ]))}
                  </td>
                  <td className="text-center"></td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="bold" colSpan={4}>
                    Add
                  </td>
                </tr>
                <tr>
                  <td className="ps-4">Overtime</td>
                  <td className="text-end">
                    {formatAmount(getSum([
                      payrollData.regular_ot_pay,
                      payrollData.restday_ot_pay,
                    ]))}
                  </td>
                  <td className="text-center">
                    {getSum([
                      payrollData.regular_ot_hr,
                      payrollData.restday_ot_hr,
                    ])}
                  </td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="ps-4">Paid Sick Leave</td>
                  <td className="text-end">
                    {formatAmount(payrollData.sick_leave_pay)}
                  </td>
                  <td className="text-center">
                    {payrollData.sick_leave_days}
                  </td>
                  <td className="">day/s</td>
                </tr>
                <tr>
                  <td className="ps-4">Paid Vacation Leave</td>
                  <td className="text-end">
                    {formatAmount(payrollData.vacation_leave_pay)}
                  </td>
                  <td className="text-center">
                    {payrollData.vacation_leave_days}
                  </td>
                  <td className="">day/s</td>
                </tr>
                {
                  parseFloat(payrollData.project_allowance)>0 &&
                  <tr>
                    <td className="ps-4">Allowances</td>
                    <td className="text-end">
                      {formatAmount(payrollData.project_allowance)}
                    </td>
                    <td className="text-center"></td>
                    <td className="">---</td>
                  </tr>
                }
                {
                  parseFloat(payrollData.ecola_allowance)>0 &&
                  <tr>
                  <td className="ps-4">ECOLA</td>
                  <td className="text-end">
                    {formatAmount(payrollData.ecola_allowance)}
                  </td>
                  <td className="text-center"></td>
                  <td className="">---</td>
                </tr>
                }
                {
                  parseFloat(payrollData.incentives)>0 &&
                  <tr>
                  <td className="ps-4">Incentives</td>
                  <td className="text-end">
                    {formatAmount(payrollData.incentives)}
                  </td>
                  <td className="text-center"></td>
                  <td className="">---</td>
                </tr>
                }
                <tr>
                  <td className="bold">Salary Adjustment</td>
                  <td colSpan={3} className="bold text-end">
                    {formatAmount(payrollData.salary_adjustment)}
                  </td>
                </tr>
                <tr>
                  <td className="bold">Total Gross Pay</td>
                  <td colSpan={3} className="bold text-end">
                    {formatAmount(payrollData.gross_pay)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={4}>
                    Less: Deductions
                  </td>
                </tr>
                <tr>
                  <td className="">Undertime</td>
                  <td className="text-end">{formatAmount(payrollData.undertime)}</td>
                  <td className="text-center">{payrollData.undertime_hr}</td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="">Late</td>
                  <td className="text-end">{formatAmount(payrollData.late)}</td>
                  <td className="text-center">{payrollData.late_hr}</td>
                  <td className="">hour/s</td>
                </tr>
                <tr>
                  <td className="">SSS</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.sss)}
                  </td>
                </tr>
                <tr>
                  <td className="">PhilHealth</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.philhealth)}
                  </td>
                </tr>
                <tr>
                  <td className="">Pag-IBIG</td>
                  <td className="text-end" colSpan={3}>
                    {formatAmount(payrollData.hdmf)}
                  </td>
                </tr>
                {parseFloat(payrollData.sss_loan) > 0 && (
                  <tr>
                    <td className="">SSS Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.sss_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.pagibig_loan) > 0 && (
                  <tr>
                    <td className="">Pag-IBIG Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.pagibig_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.ppes_loan) > 0 && (
                  <tr>
                    <td className="">PPEs Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.ppes_loan)}
                    </td>
                  </tr>
                )}

                {parseFloat(payrollData.cash_advance) > 0 && (
                  <tr>
                    <td className="">Cash Advance</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.cash_advance)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.cooperative_loan) > 0 && (
                  <tr>
                    <td className="">Cooperative Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.cooperative_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.other_loan) > 0 && (
                  <tr>
                    <td className="">Other Loan</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.other_loan)}
                    </td>
                  </tr>
                )}
                {parseFloat(payrollData.coop) > 0 && (
                  <tr>
                    <td className="">Coop Contribution</td>
                    <td className="text-end" colSpan={3}>
                      {formatAmount(payrollData.coop)}
                    </td>
                  </tr>
                )}

                <tr>
                  <td className="bold">Total Deductions</td>
                  <td className="bold text-end" colSpan={3}>
                    {formatAmount(payrollData.total_deductions)}
                  </td>
                </tr>
                <tr>
                  <td className="bold">NET PAY</td>
                  <td className="bold text-end" colSpan={3}>
                    {formatAmount(payrollData.total_net_pay)}
                  </td>
                </tr>
                <tr className="">
                  <td className="no-border-cell" colSpan={4}></td>
                </tr>
                <tr className="">
                  <td className="bold text-center" colSpan={4}>
                    Breakdown of Advances
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Balance from previous month
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.prev_balance)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Total Payments
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.total_payment)}
                  </td>
                </tr>
                <tr>
                  <td className="bold" colSpan={2}>
                    Balance still to be paid
                  </td>
                  <td className="text-end" colSpan={2}>
                    {formatAmount(payrollData.balance)}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Card>
    );
  }

  return (
    <Navbar activeNav="payroll">
      <div ref={componentRef} className="p-5">
        <Row className="d-flex justify-content-end noPrint pb-2">
          <Row>
            <ReactToPrint
              trigger={() => (
                <Button type="primary">
                  <PrinterOutlined />
                  Print
                </Button>
              )}
              content={() => componentRef.current}
              documentTitle={`${payrollData.employee_name} Payslip`}
            />
          </Row>
        </Row>
        <div className="payslip-container">
          {payrollData.salary_type === "monthly26"
            ? renderMonthlyTypePayslip()
            : renderWeeklyTypePayslip()}
        </div>
      </div>
    </Navbar>
  );
}